module.exports = __webpack_public_path__ + "img/emoji_19.0ecca34e.png";